export const LIST_PRINCIPAL_BUDGET_BY_SECTOR_ID_REQUEST = 'LIST_PRINCIPAL_BUDGET_BY_SECTOR_ID_REQUEST';
export const LIST_PRINCIPAL_BUDGET_BY_SECTOR_ID_REQUEST_SUCCESS = 'LIST_PRINCIPAL_BUDGET_BY_SECTOR_ID_REQUEST_SUCCESS';
export const LIST_PRINCIPAL_BUDGET_BY_SECTOR_ID_REQUEST_FAILURE = 'LIST_PRINCIPAL_BUDGET_BY_SECTOR_ID_REQUEST_FAILURE';

export const CLEAR_PRINCIPAL_BUDGET_LIST_BY_SECTOR_ID = 'CLEAR_PRINCIPAL_BUDGET_LIST_BY_SECTOR_ID';